/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { IEditedContent } from "src/modules/pe-landing-module/hooks/useEditedContent"
import ContentEditChildMenu from "./ContentEditChildMenu"

/* Protopia Ecosystem component */
export interface IContentEditChildProps {
    elementData: IEditedContent
    element: Element
    elementDOM: DOMRect
    type: LANDING_TYPE_CONTENT
}
const ContentEditChild = (props: IContentEditChildProps): JSX.Element => {
    const ref = useRef(null) 
    const bounds    = useSyncState<DOMRect>( props.element.getBoundingClientRect() ) 
    const id        = props.element.getAttribute(  "data-primitive-type" )
    useEffect(() => {
        bounds.set( props.element.getBoundingClientRect() )
    }, [props.element])
 
    return <div 
        className="contour-child"  
        style={{
            width: bounds.get().width,
            height: bounds.get().height,
            top: bounds.get().top - props.elementDOM.top,
            left: bounds.get().left - props.elementDOM.left
        }}
    >
        <div className='landing-content-edit-breadcrumbs' ref={ref}>
            <div className="flex-centered ml-1 flex-wrap">
                <div className="d-flex my-1">
                    <img 
                        src={ components()[props.type].icon }
                        height={ 12 }
                        className=" ml-1 panel-icon " 
                        alt=""
                    />
                </div>
                <div className="micro letter-spacing-1 text-light mx-1">
                    {__( components()[props.type].title )}
                </div>
                <ContentEditChildMenu type={ props.type } value={ props.elementData.data } />  
            </div>
        </div>
        
    </div>
}
export default ContentEditChild